module.exports = __webpack_public_path__ + "static/media/bit-active.5e972e52.jpg";